import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerCampaigns = lazy(() => import("@/pages/partner/PartnerCampaigns"));

export const Route = createFileRoute("/partner/kampanjer")({
  head: () => ({
    meta: [
      { title: "Kampanjer – Partnerportal" },
      { name: "description", content: "Hantera era elavtal och kampanjer på Elmarknad.se." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerCampaigns />,
});
